import {
  AppRuntimeConfiguration,
  computeItemIdentifier,
} from '@o3r/core';
import {
  COMPONENTS_CONFIGURATION_NAME,
} from '../configuration/index';

/**
 * App configuration
 *
 * @title Application
 */
export interface AppConfig extends AppRuntimeConfiguration {
  /**
   * Start time for the polling mechanism when confirming an alternative offer in the self reaccommodation flow.
   * The confirmation job is called to know the confirmation status every N milliseconds.
   * The value is in millisecond.
   *
   * @o3rCategory technical
   */
  pollingStartTimeConfirmationAlternativeOffer: number;

  /**
   * Time between two calls for the polling mechanism when confirming an alternative offer in the self
   * reaccommodation flow.
   * The value is in millisecond.
   *
   * @o3rCategory technical
   */
  pollingPeriodTimeConfirmationAlternativeOffer: number;

  /**
   * Maximum number of iterations for the polling mechanism when confirming an alternative offer in the self
   * reaccommodation flow.
   *
   * @o3rCategory technical
   */
  pollingMaxNbOfIterationsConfirmationAlternativeOffer: number;

  /**
   * If the bound is departing within this time, it is considered in the DCS window.
   * The value is in hours.
   *
   * @o3rCategory functionalities
   */
  dcsWindow: number;

  /**
   * RES window office id
   *
   * @o3rCategory technical
   */
  resOfficeId: string;

  /**
   * DSC window Office id
   *
   * @o3rCategory technical
   */
  dcsOfficeId: string;

  /**
   * Allow use method GET to send recloc and lastName in retrieve order
   *
   * @o3rCategory technical
   */
  enableGETQueryParamsDeeplink: boolean;

  /**
   * Enable self reaccommodation confirmation email.
   *
   * @o3rCategory functionalities
   */
  enableSelfReaccConfirmationEmail: boolean;

  /**
   * Enable self reaccommodation travel documents email.
   *
   * @o3rCategory functionalities
   */
  enableSelfReaccTravelDocumentsEmail: boolean;

  /**
   * Confirmation email layout ID.
   *
   * @o3rCategory technical
   */
  confirmationEmailLayoutId: string;

  /**
   * Whether the servicing office id from the order should be used
   *
   * @o3rCategory technical
   */
  shouldUseServicingOfficeId: boolean;

  /**
   * Whether the refund notice should be sent to the user when an order is refunded
   *
   * @o3rCategory functionalities
   */
  shouldSendRefundNotification: boolean;
}

export const APP_CONFIG_DEFAULT: AppConfig = {
  pollingStartTimeConfirmationAlternativeOffer: 0,
  pollingPeriodTimeConfirmationAlternativeOffer: 2000,
  pollingMaxNbOfIterationsConfirmationAlternativeOffer: 30,
  dcsWindow: 0,
  resOfficeId: '',
  dcsOfficeId: '',
  enableGETQueryParamsDeeplink: false,
  enableSelfReaccConfirmationEmail: true,
  enableSelfReaccTravelDocumentsEmail: false,
  confirmationEmailLayoutId: 'RFXBCNF_TN',
  shouldUseServicingOfficeId: false,
  shouldSendRefundNotification: true
};

export const APP_CONFIG_ID = computeItemIdentifier('AppConfig', COMPONENTS_CONFIGURATION_NAME);
